import { LiveRegion } from '#UNSAFE_LiveRegion';
import { TextFieldInput } from '#UNSAFE_TextField';
import { useTranslationBundle } from '#hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '#resources/nls/bundle';
import { ComponentProps, Ref } from 'preact';

type PickedTextFieldInputProps = Pick<
  ComponentProps<typeof TextFieldInput>,
  | 'aria-controls'
  | 'aria-describedby'
  | 'aria-expanded'
  | 'aria-invalid'
  | 'aria-label'
  | 'hasEmptyLabel'
  | 'hasInsideLabel'
  | 'id'
  | 'isRequired'
  | 'onBlur'
  | 'onFocus'
  | 'onInput'
  | 'onKeyDown'
  | 'onKeyUp'
  | 'placeholder'
  | 'textAlign'
  | 'variant'
> & {
  inputRef?: Ref<HTMLInputElement>;
};

type Props = PickedTextFieldInputProps & {
  displayValue: string;
  isAddToListShown: boolean;
  isAdvancedSearchShown: boolean;
  isUserFiltering: boolean;
  liveRegionText?: string;
  userInput?: string;
  virtualKeyboard?: 'auto' | 'email' | 'number' | 'search' | 'tel' | 'text' | 'url';
};

export function SelectSingleFieldInput({
  displayValue,
  isAddToListShown,
  isAdvancedSearchShown,
  isUserFiltering,
  liveRegionText,
  userInput,
  virtualKeyboard,
  ...passThroughTextFieldInputProps
}: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const addToListAccText = translations.select_addToListAvailable();
  const advancedSearchAccText = translations.select_moreSearchOptionsAvailable();

  return (
    <>
      <TextFieldInput
        {...passThroughTextFieldInputProps}
        aria-autocomplete="list"
        autoComplete="off"
        role="combobox"
        spellcheck={false}
        type={virtualKeyboard === 'auto' ? 'search' : virtualKeyboard}
        value={isUserFiltering ? userInput : displayValue}
      />
      <LiveRegion>{liveRegionText}</LiveRegion>
      {isAddToListShown ? <LiveRegion>{addToListAccText}</LiveRegion> : undefined}
      {isAdvancedSearchShown ? <LiveRegion>{advancedSearchAccText}</LiveRegion> : undefined}
    </>
  );
}
